import { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const NewTraderGuideContext = createContext(null);

export function NewTraderGuideProvider({ children }) {
  const [guideActive, setGuideActive] = useState(false);
  const [guideStep, setGuideStep] = useState(null);
  const [selectedAsset, setSelectedAssetState] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (guideActive) return;
    const persona = localStorage.getItem("qushi_onboarding_persona");
    const done = localStorage.getItem("qushi_newtrader_guide_done");
    const pending = localStorage.getItem("qushi_newtrader_guide_pending");
    const token = localStorage.getItem("accessToken");
    if (token && persona && pending === "true" && done !== "true") {
      // Consume the pending flag right away — the guide must be completed
      // in this session, otherwise it never auto-shows again.
      localStorage.removeItem("qushi_newtrader_guide_pending");
      setGuideActive(true);
      setGuideStep(1);
    }
  }, [location.pathname, guideActive]);

  const setSelectedAsset = (asset) => setSelectedAssetState(asset);

  const advanceStep = (step) => setGuideStep(step);

  const completeGuide = () => {
    localStorage.setItem("qushi_newtrader_guide_done", "true");
    localStorage.removeItem("qushi_newtrader_guide_pending");
    localStorage.removeItem("qushi_guide_step3_consumed");
    setGuideActive(false);
    setGuideStep(null);
    setSelectedAssetState(null);
  };

  return (
    <NewTraderGuideContext.Provider
      value={{
        guideActive,
        guideStep,
        selectedAsset,
        setSelectedAsset,
        advanceStep,
        completeGuide,
      }}
    >
      {children}
    </NewTraderGuideContext.Provider>
  );
}

export function useNewTraderGuide() {
  return useContext(NewTraderGuideContext);
}
